module.exports = __webpack_public_path__ + "static/img/Rectangle.595eec6e.png";